import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { map, Observable } from 'rxjs';

import { IAppRootState } from '../../core/store';
import { RankingItemEntity } from '../components/ranking-list/ranking-item.entity';
import { RankingListEntity } from '../components/ranking-list/ranking-list.entity';
import { RankingState, RankingFeatureKey } from './ranking.state';

interface RankingRootState extends IAppRootState {
	[RankingFeatureKey]: RankingState;
}

@Injectable()
export class RankingSelector {
	public constructor(private readonly store: Store<RankingRootState>) {}

	private get state(): Observable<RankingState> {
		return this.store.pipe(select((store) => store[RankingFeatureKey]));
	}
	public getLoading$(): Observable<boolean> {
		return this.state.pipe(map((state) => state.get('loading')));
	}

	public getRankingList$(): Observable<RankingListEntity> {
		return this.state.pipe(map((state) => state.get('rankingList')));
	}

	public includePublic$(): Observable<boolean> {
		return this.state.pipe(map((state) => state.get('includePublicProjects')));
	}

	public getSelectedRankings$(
		selected: Array<string>
	): Observable<Array<RankingItemEntity>> {
		return this.getRankingList$().pipe(
			map((list) =>
				selected.reduce<Array<RankingItemEntity>>((acc, curr) => {
					const maybe = list.elements.get(`${curr}`);
					if (maybe) {
						acc.push(maybe);
						return acc;
					}
					return acc;
				}, [])
			)
		);
	}
}
